<template>
<div id="index">
    <mIndex v-if="$store.state.device == 'mob'" />
    <pIndex v-if="$store.state.device == 'pc'" />
</div>
</template>

<script>
import mIndex from '@/components/mIndex.vue'
import pIndex from '@/components/pIndex.vue'
export default {
    name: 'Index',
    data (){
        return {

        }
    },
    components: {
        mIndex,
        pIndex,
    },
    computed: {

    },
    watch: {

    },
    methods: {

    },
    mounted () {
        // alert(window.innerWidth)
    }
}
</script>

<style lang="scss" scoped>

</style>
